import { Injectable, Injector, effect } from '@angular/core';
import { ACLService } from '@delon/acl';
import { SettingsService, _HttpClient } from '@delon/theme';

@Injectable()
export class EInvoiceService {

  eInvoiceSetting: any = null;
  
  get country() {
    return this.injector.get(SettingsService).user['company']?.['country'];
  }

  get isEnabled() {
    return this.acl.can('m1.8388608') && this.country === 'MY';
  }

  constructor(
    private http: _HttpClient,
    private acl: ACLService,
    private injector: Injector
  ) {
      this.http.get('api/systemdata/getEInvSettings')
      .subscribe({
        next: (setting: any) => {
          this.eInvoiceSetting = {
            ...setting,
            effectiveDate:
              setting.year && setting.month
                ? new Date(setting.year, setting.month - 1, 1)
                : null
          };
        }
      });
  }

  // Only used for power search filter
  effectiveDate() {
    if (!this.isEnabled) return null;

    if (this.eInvoiceSetting && this.eInvoiceSetting.effectiveDate) {
      return this.eInvoiceSetting.effectiveDate;
    }
    return null;
  }

  requireCustomerValidation(): boolean {
    if (!this.isEnabled) return false;

    return this.eInvoiceSetting?.eInvRequireCustomer ?? false;
  }

  requireSupplierValidation(): boolean {
    if (!this.isEnabled) return false;

    return this.eInvoiceSetting?.eInvRequireSupplier ?? false;
  }

  requireStockValidation(): boolean {
    if (!this.isEnabled) return false;

    return this.eInvoiceSetting?.eInvRequireStock ?? false;
  }
}
